import { createAction, props } from '@ngrx/store';

export const actionKey = '[Auth]';

export interface AuthCredential {
  refreshToken?: string | null;
  bearerToken: string | null;
}

export interface ResetStatus {
  resetStatus: boolean;
}

export const AuthLogin = createAction(
  `${actionKey} Login`,
  props<{ payload: { email: string; password: string; deviceId?: string } }>(),
);

export const AuthLoginFail = createAction(`${actionKey} fail`, props<{ payload: any }>());

export const AuthLogout = createAction(`${actionKey} Logout`);

export const AuthLoginSuccess = createAction(
  `${actionKey}  Login success`,
  props<{ payload: AuthCredential }>(),
);

export const SetAuthCredentials = createAction(
  `${actionKey}  set auth cred`,
  props<{ payload: AuthCredential }>(),
);

export const RefreshTokens = createAction(`${actionKey}  refresh token`);

export const RestorePassword = createAction(
  `${actionKey}  restore password`,
  props<{ payload: { emailAddress: string; confirmEmailAddress: string } }>(),
);

export const RestorePasswordSuccess = createAction(`${actionKey}  restore password success`);

export const ResetPassword = createAction(
  `${actionKey}  reset password`,
  props<{
    payload: {
      password: string;
      confirmPassword: string;
      userKey: string;
    };
  }>(),
);

export const ResetPasswordSuccess = createAction(
  `${actionKey}  reset password success`,
  props<{ payload: ResetStatus }>(),
);

export const ResetPasswordFail = createAction(
  `${actionKey}  reset password fail`,
  props<{ errorMessage: string }>(),
);

export const SetDefaultResetStatus = createAction(`${actionKey} set default reset status`);

export const VerifyUser = createAction(
  `${actionKey}  verify user`,
  props<{ payload: { userToken: string } }>(),
);

export const VerifyUserSuccess = createAction(
  `${actionKey}  verify user success`,
  props<{ payload: { verificationStatus: string } }>(),
);

export const VerifyUserFail = createAction(
  `${actionKey}  verify user fail`,
  props<{ payload: any }>(),
);

export const ResetErrors = createAction(`${actionKey}  reset errors`);

export const ResetLoaded = createAction(`${actionKey}  reset loaded`);

export const ClearResetStatus = createAction(`${actionKey} clear reset status`);
